import {
  REPORT_A_BUG_FAIL,
  REPORT_A_BUG_START,
  REPORT_A_BUG_SUCCESS,
} from './types';

export const reportABug = payload => ({
  type: REPORT_A_BUG_START,
  payload,
});

export const reportABugFail = payload => ({
  type: REPORT_A_BUG_FAIL,
  payload,
});

export const reportABugSuccess = payload => ({
  type: REPORT_A_BUG_SUCCESS,
  payload,
});
